import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=0a732837&scoped=true&lang=pug"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=0a732837&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a732837",
  null
  
)

export default component.exports